export default "__VITE_ASSET__CszurCAn__"